import { c as _c } from "react-compiler-runtime";
import { useState, useMemo, useRef, useEffect } from 'react';
import { Provider } from 'react-redux';
import { createStore } from '../../redux/createStore';
import { StoreContext } from '../../redux/storeContext';
import { createWidthsStore } from '../../redux/createWidthsStore';
import { createSelectionStore } from '../../redux/createSelectionStore';
import { WidthsStoreContext } from '../../redux/widthsStoreContext';
import { SelectionStoreContext } from '../../redux/selectionStoreContext';
import { EmptyComponent } from '../utils/EmptyComponent';
import { DEFAULT_PAGE_SIZES } from '../../pagination/constants/pageSizes';
import emptyFunction from 'react-utils/emptyFunction';
import Table from './Table';
import { ProvideAuth } from '../../auth/context/AuthContext';
import { DEFAULT_COLUMN_MINIMUM_WIDTH, DEFAULT_COLUMN_WIDTH, MINIMUM_RESIZABLE_COLUMN_WIDTH } from '../constants/sizes';
import { DefaultRowComponent } from './DefaultRowComponent';
import { DefaultTableComponent } from './DefaultTableComponent';
import { ProvideLogger } from '../../logger/context/LoggerContext';
import { ProvideFDTContextMenuConfig } from '../../contextMenu/context/FDTContextMenuConfigContext';
import DefaultSelectAllComponent from '../../selection/components/DefaultSelectAllComponent';
import { ProvideVirtualization } from '../../virtualization/VirtualizationContext';
import { getColumnKey } from '../utils/getColumnKey';
import Raven from 'raven-js';
import { BulkActionsContainerAboveTable } from './BulkActionsContainerAboveTable';
import { infiniteScrollDisabled } from '../../infiniteScroll/config';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const emptyArray = [];
const DEFAULT_NAMESPACE = 'DEFAULT_NAMESPACE';

//we explicitly prevent a column width of 0 - this || is weight bearing over ??
const getMinimumColumnWidth = column => Math.max(column.minimumColumnWidth || DEFAULT_COLUMN_MINIMUM_WIDTH,
// Below MINIMUM_RESIZABLE_COLUMN_WIDTH, users can no longer interact with column resizing and can get stuck with a too-narrow column
column.resizable ? MINIMUM_RESIZABLE_COLUMN_WIDTH : 0);
const TableWrapper = t0 => {
  const $ = _c(92);
  const {
    alternateHeaderLeftSlot: t1,
    BulkActionsComponent: t2,
    canSelectAllRecords: t3,
    columns,
    CustomSelectAllComponent: t4,
    disableScrollReset: t5,
    getRowId,
    hasGate,
    hasScope,
    headerLeftSlot: t6,
    headerRightSlot: t7,
    infiniteScrollConfig: t8,
    isBulkActionsRedesignEnabled: t9,
    isIndexRedesignEnabled: t10,
    loading: t11,
    logger: t12,
    noRowsSlot: t13,
    numberOfFrozenColumns: t14,
    onColumnOrderChange: t15,
    onColumnWidthChange: t16,
    contextMenuConfig,
    onPageIndexChange: t17,
    onPageSizeChange: t18,
    onSortsChange: t19,
    pageable: t20,
    pageIndex: t21,
    pageSize: t22,
    pageSizes: t23,
    paginatorAlignment: t24,
    reorderable: t25,
    resizable: t26,
    rows,
    RowComponent: t27,
    scrollContainerRef,
    selectable: t28,
    selectionStore: externalSelectionStore,
    sortable: t29,
    sorts: t30,
    TableComponent: t31,
    totalRowCount: t32,
    zebraStripe: t33,
    condensed: t34,
    dataDensity,
    enableFullVirtualization: t35,
    onFrozenColumnWidthAlert,
    hasTopBarBorderRadius
  } = t0;
  const alternateHeaderLeftSlot = t1 === undefined ? null : t1;
  const BulkActionsComponent = t2 === undefined ? EmptyComponent : t2;
  const canSelectAllRecords = t3 === undefined ? true : t3;
  const CustomSelectAllComponent = t4 === undefined ? DefaultSelectAllComponent : t4;
  const disableScrollReset = t5 === undefined ? false : t5;
  const headerLeftSlot = t6 === undefined ? null : t6;
  const headerRightSlot = t7 === undefined ? null : t7;
  const infiniteScrollConfig = t8 === undefined ? infiniteScrollDisabled : t8;
  const isBulkActionsRedesignEnabled = t9 === undefined ? false : t9;
  const isIndexRedesignEnabled = t10 === undefined ? false : t10;
  const loading = t11 === undefined ? false : t11;
  const logger = t12 === undefined ? emptyFunction : t12;
  const noRowsSlot = t13 === undefined ? null : t13;
  const numberOfFrozenColumns = t14 === undefined ? 0 : t14;
  const onColumnOrderChange = t15 === undefined ? emptyFunction : t15;
  const onColumnWidthChange = t16 === undefined ? emptyFunction : t16;
  const onPageIndexChange = t17 === undefined ? emptyFunction : t17;
  const onPageSizeChange = t18 === undefined ? emptyFunction : t18;
  const onSortsChange = t19 === undefined ? emptyFunction : t19;
  const pageable = t20 === undefined ? true : t20;
  const pageIndex = t21 === undefined ? 0 : t21;
  const pageSize = t22 === undefined ? DEFAULT_PAGE_SIZES[0] : t22;
  const pageSizes = t23 === undefined ? DEFAULT_PAGE_SIZES : t23;
  const paginatorAlignment = t24 === undefined ? "center" : t24;
  const reorderable = t25 === undefined ? true : t25;
  const resizable = t26 === undefined ? true : t26;
  const RowComponent = t27 === undefined ? DefaultRowComponent : t27;
  const selectable = t28 === undefined ? true : t28;
  const sortable = t29 === undefined ? true : t29;
  const sorts = t30 === undefined ? emptyArray : t30;
  const TableComponent = t31 === undefined ? DefaultTableComponent : t31;
  const totalRowCount = t32 === undefined ? 0 : t32;
  const zebraStripe = t33 === undefined ? false : t33;
  const condensed = t34 === undefined ? true : t34;
  const enableFullVirtualization = t35 === undefined ? false : t35;
  const alreadyLoggedRavenRef = useRef(false);
  let t36;
  if ($[0] !== columns || $[1] !== reorderable || $[2] !== resizable || $[3] !== sortable) {
    let t37;
    if ($[5] !== reorderable || $[6] !== resizable || $[7] !== sortable) {
      t37 = column => {
        const minimumColumnWidth = getMinimumColumnWidth(column);
        const width = Math.max(column.width || DEFAULT_COLUMN_WIDTH, minimumColumnWidth);
        return Object.assign({}, column, {
          columnNamespace: column.columnNamespace || DEFAULT_NAMESPACE,
          width,
          minimumColumnWidth,
          resizable: column.resizable != null ? column.resizable : resizable,
          reorderable: column.reorderable != null ? column.reorderable : reorderable,
          sortable: column.sortable != null ? column.sortable : sortable
        });
      };
      $[5] = reorderable;
      $[6] = resizable;
      $[7] = sortable;
      $[8] = t37;
    } else {
      t37 = $[8];
    }
    t36 = columns.map(t37);
    $[0] = columns;
    $[1] = reorderable;
    $[2] = resizable;
    $[3] = sortable;
    $[4] = t36;
  } else {
    t36 = $[4];
  }
  const columnsWithDefaults = t36;
  let t37;
  let t38;
  if ($[9] !== columns) {
    t37 = () => {
      for (const column_0 of columns) {
        const minimumColumnWidth_0 = getMinimumColumnWidth(column_0);
        if (column_0.width && column_0.width < minimumColumnWidth_0) {
          const errorExtra = {
            columnName: column_0.columnName,
            columnNamespace: column_0.columnNamespace,
            width: column_0.width,
            minimumColumnWidth: minimumColumnWidth_0
          };
          console.error("FrameworkDataTable has received a column width less than the minimum column width. We are falling back to the minimum column width, but this will cause column rendering and resizing to be extremely glitchy for users.", errorExtra);
          if (!alreadyLoggedRavenRef.current) {
            Raven.captureException(new Error("FrameworkDataTable has received a column width less than the minimum column width. We are falling back to the minimum column width, but this will cause column rendering and resizing to be extremely glitchy for users."), {
              extra: {
                errorExtra
              }
            });
            alreadyLoggedRavenRef.current = true;
          }
        }
      }
    };
    t38 = [columns];
    $[9] = columns;
    $[10] = t37;
    $[11] = t38;
  } else {
    t37 = $[10];
    t38 = $[11];
  }
  useEffect(t37, t38);
  let t39;
  if ($[12] !== columnsWithDefaults) {
    t39 = () => createWidthsStore({
      initialWidths: columnsWithDefaults.reduce(_temp, {})
    });
    $[12] = columnsWithDefaults;
    $[13] = t39;
  } else {
    t39 = $[13];
  }
  const [widthsStore] = useState(t39);
  let t40;
  if ($[14] !== externalSelectionStore) {
    t40 = () => externalSelectionStore ? null : createSelectionStore();
    $[14] = externalSelectionStore;
    $[15] = t40;
  } else {
    t40 = $[15];
  }
  const [internalSelectionStore] = useState(t40);
  const selectionStore = externalSelectionStore !== null && externalSelectionStore !== void 0 ? externalSelectionStore : internalSelectionStore;
  const [store] = useState(_temp2);
  let t41;
  if ($[16] !== sorts) {
    t41 = sorts.map(_temp3);
    $[16] = sorts;
    $[17] = t41;
  } else {
    t41 = $[17];
  }
  const sortsWithDefaults = t41;
  const shouldShowBulkActionsContainerAboveTable = isBulkActionsRedesignEnabled && isIndexRedesignEnabled;
  let t42;
  if ($[18] !== BulkActionsComponent || $[19] !== canSelectAllRecords || $[20] !== getRowId || $[21] !== isBulkActionsRedesignEnabled || $[22] !== isIndexRedesignEnabled || $[23] !== rows || $[24] !== shouldShowBulkActionsContainerAboveTable || $[25] !== totalRowCount) {
    t42 = shouldShowBulkActionsContainerAboveTable && /*#__PURE__*/_jsx(BulkActionsContainerAboveTable, {
      BulkActionsComponent: BulkActionsComponent,
      canSelectAllRecords: canSelectAllRecords,
      getRowId: getRowId,
      isBulkActionsRedesignEnabled: isBulkActionsRedesignEnabled,
      isIndexRedesignEnabled: isIndexRedesignEnabled,
      rows: rows,
      totalRowCount: totalRowCount
    });
    $[18] = BulkActionsComponent;
    $[19] = canSelectAllRecords;
    $[20] = getRowId;
    $[21] = isBulkActionsRedesignEnabled;
    $[22] = isIndexRedesignEnabled;
    $[23] = rows;
    $[24] = shouldShowBulkActionsContainerAboveTable;
    $[25] = totalRowCount;
    $[26] = t42;
  } else {
    t42 = $[26];
  }
  let t43;
  if ($[27] !== BulkActionsComponent || $[28] !== CustomSelectAllComponent || $[29] !== RowComponent || $[30] !== TableComponent || $[31] !== alternateHeaderLeftSlot || $[32] !== canSelectAllRecords || $[33] !== columnsWithDefaults || $[34] !== condensed || $[35] !== dataDensity || $[36] !== disableScrollReset || $[37] !== enableFullVirtualization || $[38] !== getRowId || $[39] !== hasTopBarBorderRadius || $[40] !== headerLeftSlot || $[41] !== headerRightSlot || $[42] !== infiniteScrollConfig || $[43] !== isBulkActionsRedesignEnabled || $[44] !== isIndexRedesignEnabled || $[45] !== loading || $[46] !== noRowsSlot || $[47] !== numberOfFrozenColumns || $[48] !== onColumnOrderChange || $[49] !== onColumnWidthChange || $[50] !== onFrozenColumnWidthAlert || $[51] !== onPageIndexChange || $[52] !== onPageSizeChange || $[53] !== onSortsChange || $[54] !== pageIndex || $[55] !== pageSize || $[56] !== pageSizes || $[57] !== pageable || $[58] !== paginatorAlignment || $[59] !== reorderable || $[60] !== resizable || $[61] !== rows || $[62] !== scrollContainerRef || $[63] !== selectable || $[64] !== sortable || $[65] !== sortsWithDefaults || $[66] !== totalRowCount || $[67] !== zebraStripe) {
    t43 = /*#__PURE__*/_jsx(Table, {
      alternateHeaderLeftSlot: alternateHeaderLeftSlot,
      BulkActionsComponent: BulkActionsComponent,
      canSelectAllRecords: canSelectAllRecords,
      scrollContainerRef: scrollContainerRef,
      columns: columnsWithDefaults,
      condensed: condensed,
      dataDensity: dataDensity,
      CustomSelectAllComponent: CustomSelectAllComponent,
      disableScrollReset: disableScrollReset,
      enableFullVirtualization: enableFullVirtualization,
      getRowId: getRowId,
      headerLeftSlot: headerLeftSlot,
      headerRightSlot: headerRightSlot,
      infiniteScrollConfig: infiniteScrollConfig,
      isBulkActionsRedesignEnabled: isBulkActionsRedesignEnabled,
      isIndexRedesignEnabled: isIndexRedesignEnabled,
      loading: loading,
      noRowsSlot: noRowsSlot,
      numberOfFrozenColumns: numberOfFrozenColumns,
      onColumnOrderChange: onColumnOrderChange,
      onColumnWidthChange: onColumnWidthChange,
      onFrozenColumnWidthAlert: onFrozenColumnWidthAlert,
      onPageIndexChange: onPageIndexChange,
      onPageSizeChange: onPageSizeChange,
      onSortsChange: onSortsChange,
      pageable: pageable,
      pageIndex: pageIndex,
      pageSize: pageSize,
      pageSizes: pageSizes,
      paginatorAlignment: paginatorAlignment,
      reorderable: reorderable,
      resizable: resizable,
      RowComponent: RowComponent,
      rows: rows,
      selectable: selectable,
      sorts: sortsWithDefaults,
      sortable: sortable,
      TableComponent: TableComponent,
      totalRowCount: totalRowCount,
      zebraStripe: zebraStripe,
      hasTopBarBorderRadius: hasTopBarBorderRadius
    });
    $[27] = BulkActionsComponent;
    $[28] = CustomSelectAllComponent;
    $[29] = RowComponent;
    $[30] = TableComponent;
    $[31] = alternateHeaderLeftSlot;
    $[32] = canSelectAllRecords;
    $[33] = columnsWithDefaults;
    $[34] = condensed;
    $[35] = dataDensity;
    $[36] = disableScrollReset;
    $[37] = enableFullVirtualization;
    $[38] = getRowId;
    $[39] = hasTopBarBorderRadius;
    $[40] = headerLeftSlot;
    $[41] = headerRightSlot;
    $[42] = infiniteScrollConfig;
    $[43] = isBulkActionsRedesignEnabled;
    $[44] = isIndexRedesignEnabled;
    $[45] = loading;
    $[46] = noRowsSlot;
    $[47] = numberOfFrozenColumns;
    $[48] = onColumnOrderChange;
    $[49] = onColumnWidthChange;
    $[50] = onFrozenColumnWidthAlert;
    $[51] = onPageIndexChange;
    $[52] = onPageSizeChange;
    $[53] = onSortsChange;
    $[54] = pageIndex;
    $[55] = pageSize;
    $[56] = pageSizes;
    $[57] = pageable;
    $[58] = paginatorAlignment;
    $[59] = reorderable;
    $[60] = resizable;
    $[61] = rows;
    $[62] = scrollContainerRef;
    $[63] = selectable;
    $[64] = sortable;
    $[65] = sortsWithDefaults;
    $[66] = totalRowCount;
    $[67] = zebraStripe;
    $[68] = t43;
  } else {
    t43 = $[68];
  }
  let t44;
  if ($[69] !== store || $[70] !== t42 || $[71] !== t43) {
    t44 = /*#__PURE__*/_jsxs(Provider, {
      store: store,
      context: StoreContext,
      children: [t42, t43]
    });
    $[69] = store;
    $[70] = t42;
    $[71] = t43;
    $[72] = t44;
  } else {
    t44 = $[72];
  }
  let t45;
  if ($[73] !== selectionStore || $[74] !== t44) {
    t45 = /*#__PURE__*/_jsx(Provider, {
      store: selectionStore,
      context: SelectionStoreContext,
      children: t44
    });
    $[73] = selectionStore;
    $[74] = t44;
    $[75] = t45;
  } else {
    t45 = $[75];
  }
  let t46;
  if ($[76] !== t45 || $[77] !== widthsStore) {
    t46 = /*#__PURE__*/_jsx(Provider, {
      store: widthsStore,
      context: WidthsStoreContext,
      children: t45
    });
    $[76] = t45;
    $[77] = widthsStore;
    $[78] = t46;
  } else {
    t46 = $[78];
  }
  let t47;
  if ($[79] !== contextMenuConfig || $[80] !== t46) {
    t47 = /*#__PURE__*/_jsx(ProvideFDTContextMenuConfig, {
      contextMenuConfig: contextMenuConfig,
      children: t46
    });
    $[79] = contextMenuConfig;
    $[80] = t46;
    $[81] = t47;
  } else {
    t47 = $[81];
  }
  let t48;
  if ($[82] !== enableFullVirtualization || $[83] !== t47) {
    t48 = /*#__PURE__*/_jsx(ProvideVirtualization, {
      enableFullVirtualization: enableFullVirtualization,
      children: t47
    });
    $[82] = enableFullVirtualization;
    $[83] = t47;
    $[84] = t48;
  } else {
    t48 = $[84];
  }
  let t49;
  if ($[85] !== logger || $[86] !== t48) {
    t49 = /*#__PURE__*/_jsx(ProvideLogger, {
      logger: logger,
      children: t48
    });
    $[85] = logger;
    $[86] = t48;
    $[87] = t49;
  } else {
    t49 = $[87];
  }
  let t50;
  if ($[88] !== hasGate || $[89] !== hasScope || $[90] !== t49) {
    t50 = /*#__PURE__*/_jsx(ProvideAuth, {
      hasScope: hasScope,
      hasGate: hasGate,
      children: t49
    });
    $[88] = hasGate;
    $[89] = hasScope;
    $[90] = t49;
    $[91] = t50;
  } else {
    t50 = $[91];
  }
  return t50;
};
export default TableWrapper;
function _temp(acc, column_1) {
  const width_0 = column_1.width || DEFAULT_COLUMN_WIDTH;
  acc[getColumnKey(column_1.columnNamespace || DEFAULT_NAMESPACE, column_1.columnName)] = width_0;
  return acc;
}
function _temp2() {
  return createStore();
}
function _temp3(sort) {
  return Object.assign({}, sort, {
    columnNamespace: sort.columnNamespace != null ? sort.columnNamespace : DEFAULT_NAMESPACE
  });
}